const styles = theme => ({
  paper: theme.mixins.gutters({
    paddingTop: 28,
    paddingBottom: 28,
    marginTop: 32,
    marginBottom: 16,
    boxShadow: 'none'
  }),
  iconContainer: {
    width: 48,
    height: 48,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#eef3f9',
    borderRadius: 4
  },
  icon: {
    color: '#1C408C',
    fontSize: 28
  },
  description: {
    marginTop: 8,
    lineHeight: 1.6
  },
  process: {
    marginTop: 16,
    padding: 14,
    borderLeft: '3px solid #1C408C',
    backgroundColor: '#f5f7fa',
    lineHeight: 1.6
  },
  success: {
    marginTop: 16,
    color: '#2e7d32',
    fontWeight: 500
  },
  error: {
    marginTop: 16,
    color: '#c62828',
    fontWeight: 500
  },
  notice: {
    marginTop: 16,
    color: '#616161'
  },
  requestButton: {
    marginTop: 24,
    backgroundColor: '#1C408C',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#15336f'
    },
    '&:disabled': {
      backgroundColor: '#d5d9df',
      color: '#747b85'
    }
  },
  buttonIcon: {
    marginRight: 8,
    fontSize: 20
  }
})

export default styles
